declare const bootstrap: any;

import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from '../../../services/dashboard.service';
import { MeterValidationRegionData } from '../../../models/meter-validation.model';
import { UtilitySharedService } from '../../../services/shared//utility-shared.service';

@Component({
  selector: 'lib-dashboard-meter-validation',
  standalone: false,
  templateUrl: './dashboard-meter-validation.component.html',
  styleUrls: ['./dashboard-meter-validation.component.scss'],
})
export class DashboardMeterValidationComponent implements OnInit {
  constructor(
    private dashboardService: DashboardService,
    private toastr: ToastrService,
    private utilitySharedService: UtilitySharedService
  ) {}

  async ngOnInit(): Promise<void> {
    this.getMeterValidationStats();
    this.calculateSummary();
  }
  totalCount: number = 0;
  totalValidatedCount: number = 0;
  validationPercentage: number = 0;
  meterValidationRegionData: MeterValidationRegionData[] = [];
  selectedRegionData?: MeterValidationRegionData;
  defaultLat: number = 6.586116;
  defaultLng: number = 3.275217;
  mapReady = false;
  center!: google.maps.LatLngLiteral;

  private calculateSummary() {
    this.meterValidationRegionData.forEach((meterValidationRegion) => {
      this.totalCount += meterValidationRegion.totalCount ?? 0;
      this.totalValidatedCount += meterValidationRegion.validatedCount ?? 0;
    });

    this.validationPercentage =
      this.totalCount > 0
        ? (this.totalValidatedCount / this.totalCount) * 100
        : 0;
  }

  getMeterValidationStats() {
    const utilityId = this.utilitySharedService.getUtilityId();
    this.dashboardService.getDashboardMeterValidation(utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.meterValidationRegionData = responseData.data;

          this.calculateSummary();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (error) => {
        this.toastr.error('Error occured');
      },
    });
  }

  openDetailsModal(regionData?: MeterValidationRegionData) {
    this.selectedRegionData = regionData;
    this.mapReady = false;

    const el = document.getElementById('regionBreakdownModal');
    if (!el) return;

    const modal = new bootstrap.Modal(el);

    el.addEventListener(
      'shown.bs.modal',
      () => {
        this.center = {
          lat: this.selectedRegionData?.latitude ?? this.defaultLat,
          lng: this.selectedRegionData?.longitude ?? this.defaultLng,
        };
        this.mapReady = true;
      },
      { once: true }
    );

    modal.show();
  }

  mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,
    zoomControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    mapTypeId: 'satellite',
    draggable: false,
    scrollwheel: false,
    gestureHandling: 'none',
    disableDoubleClickZoom: true,
    zoom: 15,
    keyboardShortcuts: false,
    clickableIcons: false,
    styles: [
      {
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
        ],
      },
      {
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'on',
          },
        ],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#616161',
          },
        ],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#f5f5f5',
          },
        ],
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#bdbdbd',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#eeeeee',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#757575',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e5e5e5',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#757575',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            color: '#dadada',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#616161',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e5e5e5',
          },
        ],
      },
      {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [
          {
            color: '#eeeeee',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#c9c9c9',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
    ],
  };
}
